// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#publishpress-future-block-editor .components-checkbox-control__label {
    max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-manual-selection/block-editor/css/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB","sourcesContent":["#publishpress-future-block-editor .components-checkbox-control__label {\n    max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
